import { makeStyles } from "@material-ui/core";
import { Height } from "@mui/icons-material";

export const useStyles = makeStyles((theme) => ({
    card: {
        border: '1px solid #ccc',
        borderRadius: '3px',
        display: 'flex',
      },
      greenLine: {
        borderLeft: '9px solid #56AF31',
        paddingLeft: '10px',
      },
      content: {
        padding: '16px',
        width: '100%',
        margin: '28px 0',
        // backgroundColor: 'red',
        [theme.breakpoints.down('xs')]: {
            padding: '10px',
            margin: '15px 0',
        },
        [theme.breakpoints.down('sm')]: {
            width: '80%',
        },
      },
      mainContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '30px',
        flexDirection: 'row',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '15px',
        },
      },
      imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '332px',
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
        },
      },
      cardImage: {
        width: '100%',
        maxWidth: '332px',
        height: 'auto',
        [theme.breakpoints.down('xs')]: {
            maxWidth: '186px',
        },
        [theme.breakpoints.down('sm')]: {
          maxWidth: '100%',
        }
      },
      detailsContainer: {
        flex: 1,
      },
      titleContainer: {
        flexWrap: 'wrap',
        [theme.breakpoints.down('xs')]: {
            marginTop: '10px',
        },
      },
      detailsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
        gap: '10px',
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
        },
      },
      CustomTitle: {
        fontFamily: theme.fonts.family.secondary,
        fontWeight: "900",
        color: "#0f5cac",
        margin: 0,
        fontSize: "16px",
        [theme.breakpoints.down('sm')]: {
            fontSize: "14px !important",
            fontWeight: "900",
        },
      },
      separator: {
        margin: '0 14px 20px 14px',
        fontSize: '14px',
        [theme.breakpoints.down('xs')]: {
            margin: '0 8px 20px 8px',
        },
      },
      statusText: {
        fontSize: '12px',
        fontWeight: '100',
        margin: '0px',
      },
      declinedReason: {
        margin: '0px',
        color: '#B0B0B0',
        fontSize: '12px',
      },
      amountContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
      },
      approvedAmount: {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#56AF31',
        [theme.breakpoints.down('sm')]: {
          fontSize: '12px !important',
        }
      },
      arrowIcon: {
        fontSize: '14px',
        color: '#666',
      },
      requestedAmount: {
        fontSize: '14px',
        color: '#666',
        textDecoration: 'line-through',
        [theme.breakpoints.down('sm')]: {
          fontSize: '12px !important',
        }
      },
}));

